import { useState } from "react";

import * as S from "./styles";

import { Tab } from "../../../TabHeader";
import { StepModalTemplate } from "templates/StepModalTemplate";
import {
  convertExcel,
  createMany,
  downloadSubClientModel,
} from "services/SubClientServices";
import { AutoComplete } from "../../../Autocomplete";
import { IClient } from "interfaces/Client";
import { fireAlert } from "services/sweetAlertConfig";
import { useDataList } from "hooks/useDataList";

type Props = {
  opened: boolean;
  setOpened: (value: boolean) => void;
};

const tabs: Tab[] = [{ index: 0, text: "Sub Cliente" }];

export function StepRegisterManySubClient({ opened, setOpened }: Props) {
  const [tab, setTab] = useState<Tab>(tabs[0]);

  const [sending, setSending] = useState<boolean>(false);
  const [client, setClient] = useState<IClient>();
  const [file, setFile] = useState<File | undefined>(undefined);

  const clientsData = useDataList<IClient>({
    queryKey: 'listAllClients',
    route: 'clients',
    filter: {
      notPage: true,
    }
  }).data;

  async function handleSubmit() {
    setSending(true);
    if (file && client) {
      const clients = await convertExcel({ file, clientId: client.id });
      await createMany(clients)
        .then(() => {
          localStorage.setItem(
            "message",
            "Sub-clientes cadastrados com sucesso."
          );
          window.location.reload();
        })
        .catch((err) => {
          setSending(false);
          fireAlert("error", "Algo deu errado");
        });
    }
    setSending(false);
    if (!file && !client) {
      fireAlert("error", "Nenhum arquivo nem cliente escolhido");
      return;
    }
    if (!file) {
      fireAlert("error", "Nenhum arquivo escolhido");
    }
    if (!client) {
      fireAlert("error", "Nenhum cliente escolhido");
    }
    return;
  }

  function onTabClick(_tab: Tab) {
    setTab(_tab);
  }

  return (
    <StepModalTemplate
      deactivatedTabs={[]}
      opened={opened}
      setOpened={setOpened}
      buttonText={sending ? "...Carrengando" : "Efetuar cadastro"}
      handleSubmit={handleSubmit}
      tabs={tabs}
      setSelectedTab={onTabClick}
      selectedTab={tab}
      sending={sending}
      title={`Cadastrar Sub Cliente`}
      invalidTabs={[]}
      isOneTabModal
    >
      <S.Container>
        <S.AutoCompleteContainer>
          {clientsData && (
            <AutoComplete
              id="client"
              label="Selecione um cliente"
              options={clientsData.items}
              getOptionLabel={(client) => client.name}
              onChange={(selected) => {
                setClient(selected as IClient);
              }}
            />
          )}
        </S.AutoCompleteContainer>
        <S.Grid>
          <S.LabelButton>
            <input
              autoComplete="off"
              type="file"
              accept=".xlsx"
              id="input"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const file = e.target.files?.item(0);
                if (file) {
                  setFile(file);
                }
              }}
            />

            {file ? <p>{file.name}</p> : <p>Escolha um arquivo .xlsx</p>}
          </S.LabelButton>
          <S.LabelButton
            role="button"
            onClick={() => {
              downloadSubClientModel();
            }}
          >
            <p>Baixar modelo</p>
          </S.LabelButton>
        </S.Grid>
      </S.Container>
    </StepModalTemplate>
  );
}
